<template>
    <div :class="$style.container"
         v-loading.fullscreen.lock.body="loading"
         element-loading-text="拼命加载中"
         element-loading-spinner="el-icon-loading"
         element-loading-background="rgba(0, 0, 0, 0.8)"
    >

        <div :class="$style.top">
            <section :class="$style.item">
                <div :class="$style.map" id="mapContainer">
                    <el-amap class="amap-box" :vid="'amap-vue'" :center="center" :zoom="zoom" :amapManager="amapManager"
                             :plugin="plugin">
                        <el-amap-marker v-for="(marker, index) in markers" :position="marker.position"
                                        :visible="marker.visible" :vid="index" :key="marker.template"
                                        :events="marker.events">
                        </el-amap-marker>

                        <el-amap-text v-for="(text, index) in texts" :text="text.name" :key="index"
                                      :offset="text.offset" :position="text.position" :events="text.events">
                        </el-amap-text>

                    </el-amap>
                </div>
            </section>
        </div>
        <el-row>

            <el-col :span="24" :class="$style.wrapper" class="subjectList">
                <div :class="$style.top">
                    <el-form ref="form" :model="form" label-width="120px" :disabled="!isAdmin">
                        <el-form-item label="名称(必填)">
                            <el-input v-model="storeInfoObj.store_name" placeholder="请输入门店名称"></el-input>
                        </el-form-item>
                        <el-form-item label="类型(必填)" prop="templates" class="a_modal">
                            <el-select v-model="storeInfoObj.key"
                                       placeholder="选择门店所属的类型">
                                <el-option v-for="item in storeTypeArray" :key="item.key"
                                           :label="item.value1"
                                           :value="item.key">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="编码">
                            <el-input v-model="storeInfoObj.store_code" placeholder="请输入门店编码"></el-input>
                        </el-form-item>
                        <el-form-item label="所属省份(必选)" prop="templates" class="a_modal">
                            <el-select v-model="storeInfoObj.province_id"
                                       placeholder="请选择门店所属的省份" @change="handleChange">
                                <el-option v-for="item in provincesArray" :key="item.province_id"
                                           :label="item.province_name"
                                           :value="item.province_id">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="所属城市(必选)" class="a_modal">
                            <el-select v-model="storeInfoObj.city_id"
                                       placeholder="请选择门店所属的城市">
                                <el-option v-for="item in cityArray" :key="item.city_id"
                                           :label="item.city_name"
                                           :value="item.city_id">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="地址(必填)">
                            <el-input v-model="storeInfoObj.address" placeholder="请输入门店的地址"></el-input>
                        </el-form-item>
                        <el-form-item label="邮编">
                            <el-input v-model="storeInfoObj.postcode" placeholder="请输入门店的邮政编码"></el-input>
                        </el-form-item>
                        <el-form-item label="电话">
                            <el-input v-model="storeInfoObj.telephone" placeholder="请输入门店的联系电话"></el-input>
                        </el-form-item>
                        <el-form-item label="门店等级" class="a_modal">
                            <el-select v-model="storeInfoObj.segment_id"
                                       placeholder="请选择门店的等级">
                                <el-option v-for="item in rankArray" :key="item.segment_id"
                                           :label="item.segment_name"
                                           :value="item.segment_id">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="门店星级">
                            <el-rate
                                    class="rate"
                                    v-model="storeInfoObj.stars"
                                    void-color="#ff9900"
                                    text-color="#ff9900">

                            </el-rate>
                        </el-form-item>

                        <el-form-item label="所属区域" class="a_modal">
                            <el-select v-model="storeInfoObj.sales_region" placeholder="请选择区域">
                                <el-option
                                        v-for="item in areaArray"
                                        :key="item.key"
                                        :label="item.value1"
                                        :value="item.key">
                                    <span style="float: left">{{ item.value1}}</span>
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="销售主管(必选)" class="a_modal">
                            <el-select v-model="user_id" filterable multiple placeholder="请选择"
                                       @change="handleUserChange">
                                <el-option v-for="item in directorArray" :key="item.user_id"
                                           :label="item.last_name"
                                           :value="item.user_id">
                                </el-option>
                            </el-select>
                        </el-form-item>

                        <el-form-item label="启用">
                            <el-switch
                                    v-model="storeInfoObj.status"
                                    active-color="#13ce66"
                                    inactive-color="#ff4949">
                            </el-switch>
                        </el-form-item>

                    </el-form>

                </div>
            </el-col>
            <el-col :span="2"></el-col>
        </el-row>


        <el-dialog :visible.sync="showAmapDialog" :show-close="false" width="50%">
            <div slot="title" :class="$style.title">
                <span>编辑坐标</span>
                <div>
                    <el-button type="primary" size="small" @click.stop="handleSaveClick">确定</el-button>
                    <el-button type="danger" size="small" @click.stop="closeModal">取消</el-button>
                </div>
            </div>

            <div :class="$style.map">
                <div class="amap-page-container">
                <el-amap
                        vid="amapDemo"
                        :center="center"
                        :zoom="zoom"
                        :amapManager="amapManager"
                        class="amap-demo"
                        :plugin="plugin">
                    <el-amap-marker
                            :position="center" :draggable="true" :events="edit_markers.events">
                    </el-amap-marker>
                </el-amap>
                    <div align="center" style="width: 100%;margin-top: 10px">
                        <span>拖拽移动图标进行编辑</span>
                    </div>

                </div>

            </div>
        </el-dialog>

    </div>
</template>

<script>
    import http from '../../../APIService/http'
    import {bus} from '../../../router/index.js'
    import {AMapManager} from "vue-amap"

    let amapManager = new AMapManager();
    export default {
        data() {
            let self = this;
            return {
                loading: false,
                isAdmin: false,
                showAmapDialog: false,
                amapManager,
                zoom: 8,
                center: [116.46, 39.92],
                markers: [
                    {
                        position: [116.46, 39.92],
                        events: {
                            click: () => {

                                if(this.texts[0].name){
                                    this.texts[0].name = ''
                                }else {

                                    let name = "名称：" + self.storeInfoObj.store_name
                                    let address = "地址：" + self.storeInfoObj.address

                                    this.texts[0].name = "<span style='font-size: 14px;margin: 5px'>" + name + "</span>" + "<br/>" +
                                        "<span style='font-size: 14px;margin: 5px'>" + address + "</span>" + "<br/>"

                                    let userObj = this.$store.getters.getUser
                                    if(userObj.role === 'admin'){
                                        this.texts[0].name = this.texts[0].name +
                                            "<span style='color: #FF9901;font-size: 14px;margin: 5px;float: right;cursor:pointer'>编辑坐标</span>"
                                    }

                                }

                            }
                        },
                        visible: true,
                        template: '1'
                    }
                ],
                edit_markers:
                    {
                        position:[],
                        events: {
                            dragend: (e) => {//拖拽结束

                                this.edit_markers.position = [e.lnglat.lng, e.lnglat.lat];
                            }
                        },
                        visible: true,
                    },
                texts: [
                    {
                        position: [116.46, 39.92],
                        name: '',
                        offset: [0, -65],
                        events: {
                            click: () => {

                                let userObj = this.$store.getters.getUser

                                if(this.texts[0].name && userObj.role === 'admin'){
                                    self.showAmapDialog = true
                                }

                            }
                        }
                    }
                ],
                plugin: [{
                    pName: 'Scale',
                    events: {
                        init(instance) {

                        }
                    }
                }],
                storeInfoObj: {},
                user_id: [],
                storeTypeArray: [],
                provincesArray: [],
                cityArray: [],
                rankArray: [],
                areaArray: [],
                directorArray: [],
            }
        },
        created() {

            bus.$off('action_saveStoreInfo');
            bus.$on('action_saveStoreInfo', (value) => {

                this.saveStoreInfo()

            })

            this.storeInfoObj = this.$store.getters.getStore

            if (this.storeInfoObj.id) {
                let user = this.$store.getters.getUser
                if (user.role === 'admin') {
                    this.isAdmin = true
                }

                this.initInfo()
            }
        },
        components: {},
        computed: {

        },
        methods: {

            async initInfo() {
                try {

                    this.loading = true

                    var user = this.$store.getters.getUser
                    let data = {
                        tenant_id: user.tenant_id,
                        store_id: this.storeInfoObj.id,
                        user_id: user.user_id
                    }
                    await http.post('/wapi/v1/getStoreInfo', data).then(res => {

                        this.storeInfoObj = res.data.storeInfo
                        this.user_id = res.data.storeInfo.network_user_id
                        //如果省份不为空，去获取城市
                        if (this.storeInfoObj.province_id) {
                            this.getCityData(this.storeInfoObj.province_id)
                        }

                        if (this.storeInfoObj.status === 'ACTIVE') {
                            this.storeInfoObj.status = true
                        } else {
                            this.storeInfoObj.status = false
                        }
                        this.storeTypeArray = res.data.storeTypeArray
                        this.provincesArray = res.data.provinceArray
                        this.rankArray = res.data.segmentArray
                        this.areaArray = res.data.regionArray
                        this.directorArray = res.data.ouArray

                        //设置地图
                        this.zoom = 14
                        this.center = [
                            parseFloat(this.storeInfoObj.lng), parseFloat(this.storeInfoObj.lat)
                        ]
                        this.markers[0].position = [parseFloat(this.storeInfoObj.lng), parseFloat(this.storeInfoObj.lat)]

                        this.texts[0].position = [parseFloat(this.storeInfoObj.lng), parseFloat(this.storeInfoObj.lat)]

                        this.edit_markers.position = this.texts[0].position
                        // this.startSearch()

                        //当前登录人是否为销售主管和是否为组织架构主管
                        let user = this.$store.getters.getUser
                        user.isSalesDirector = this.storeInfoObj.isSalesDirector
                        user.isManage = this.storeInfoObj.isManage

                        this.loading = false
                    })
                } catch (err) {
                    this.loading = false
                    this.error()
                }
            },
            startSearch() {

                let vm = this;
                let map = this.amapManager.getMap();

                AMapUI.loadUI(['misc/PositionPicker'], function (PositionPicker) {
                    var positionPicker = new PositionPicker({
                        mode: 'dragMap',
                        map: map
                    });
                    positionPicker.start();

                    positionPicker.on('success', function (positionResult) {

                        // vm.center = [positionResult.position.lng, positionResult.position.lat];
                        //
                        vm.storeInfoObj.lat = positionResult.position.lat
                        vm.storeInfoObj.lng = positionResult.position.lng
                    })

                })
            },
            async saveStoreInfo() {
                try {

                    if (!this.storeInfoObj.store_name) {
                        this.error('名称不能为空')
                        return
                    }

                    if (!this.storeInfoObj.key) {
                        this.error('类型不能为空')
                        return
                    }

                    if (!this.storeInfoObj.province_id) {
                        this.error('省份不能为空')
                        return
                    }

                    if (!this.storeInfoObj.city_id) {
                        this.error('城市不能为空')
                        return
                    }

                    if (!this.storeInfoObj.address) {
                        this.error('地址不能为空')
                        return
                    }

                    if (this.storeInfoObj.network_user_id.length === 0) {
                        this.error('请至少选择一名销售主管')
                        return
                    }


                    this.loading = true

                    var user = this.$store.getters.getUser
                    let data = {
                        tenant_id: user.tenant_id,
                        store_code: this.storeInfoObj.store_code,
                        store_name: this.storeInfoObj.store_name,
                        store_type: this.storeInfoObj.key,
                        province_id: this.storeInfoObj.province_id,
                        city_id: this.storeInfoObj.city_id,
                        address: this.storeInfoObj.address,
                        postcode: this.storeInfoObj.postcode,
                        telephone: this.storeInfoObj.telephone,
                        area_sqm: '0',
                        status: this.storeInfoObj.status ? 'ACTIVE' : 'INACTIVE',
                        segment_id: this.storeInfoObj.segment_id,
                        region: this.storeInfoObj.sales_region,
                        stars: this.storeInfoObj.stars,
                        store_id: this.storeInfoObj.id,
                        lat: this.storeInfoObj.lat,
                        lng: this.storeInfoObj.lng,
                        location_name: this.storeInfoObj.location_name ? this.storeInfoObj.location_name : '',
                        location_id: this.storeInfoObj.location_id,
                        user_id: this.user_id
                    }

                    let dataObj = {
                        service_id: 'r365_server',
                        username: user.username,
                        token: 'f3aef14f-a44d-4a76-8b39-6088d527be4f',
                        data: data
                    }
                    await http.post('/wapi/v1/modifyStore', dataObj).then(res => {


                        if (res.success) {
                            this.$message({message: '保存成功', type: 'success'});
                        } else {
                            this.$message({message: res.message, type: 'error'});
                        }
                        this.loading = false
                    })
                } catch (err) {
                    this.loading = false
                    this.error()
                }
            },
            async getCityData(province_id) {
                try {

                    let data = {
                        province_id: province_id
                    }
                    await http.post('/wapi/v1/getCityData', data).then(res => {

                        this.cityArray = res.data

                    })
                } catch (err) {
                    this.error()
                }
            },
            handleSaveClick() {

                this.markers[0].position = this.edit_markers.position

                this.texts[0].position = this.edit_markers.position

                this.center = this.edit_markers.position

                this.storeInfoObj.lng = this.edit_markers.position[0]
                this.storeInfoObj.lat = this.edit_markers.position[1]

                this.showAmapDialog = false
            },
            closeModal(){
                this.showAmapDialog = false
            },
            handleUserChange(value) {
                this.user_id = value
            },
            handleChange(value) {
                this.storeInfoObj.city_id = ''
                this.getCityData(value)
            },
            handleClose(done) {
                this.fileObj.fileList = []
                this.dialogVisible = false
//                this.$confirm('确认关闭？')
//                    .then(_ => {
                done();
//                    })
//                    .catch(_ => {});
            },
        }
    }
</script>
<style lang="scss" module>
    @import '../../../assets/css/default';

    .container {
        .top {
            .item {
                display: flex;
                flex-direction: row;
                flex-wrap: nowrap;
                ul {
                    display: flex;
                    flex-direction: row;
                    flex-wrap: nowrap;
                    justify-items: center;
                    li {
                        margin-left: 30px;
                        font-size: 14px;
                        color: #4a90e2;
                        text-align: left;
                    }
                }
                .map {
                    width: 100%;
                    height: 200px;
                    margin: 0 0 20px 0;

                }
            }

        }
        .title {
            display: flex;
            flex-direction: row;
            flex-wrap: nowrap;
            justify-content: space-between;
            align-items: center;
            border-bottom: 2px dotted #e7eaec;
            padding-bottom: 10px;
            > span {
                color: #3998f7;
                font-size: 16px;
            }
        }
        .map {
            width: 100%;
            margin: -20px 0 20px 0;
        }
    }
</style>
<style scoped>
    .subjectList >>> .el-form-item__label {
        font-size: 14px;
        color: #000000;
        text-align: left;
        font-weight: bold;
    }

    .rate >>> .el-rate__icon {
        font-size: 32px;
    }

    .a_modal >>> .el-select {
        width: 100%;
    }

    .amap-page-container {
        height: 300px;
        position: relative;
    }
    /*.a_modal >>> .el-select .el-tag{*/
    /*background-color: #FF9901;*/
    /*}*/

    /*.a_modal >>> .el-tag--info{*/
    /*color: #ffffff;*/
    /*}*/

</style>



// WEBPACK FOOTER //
// src/pages/stores/storesInfo/index.vue